export const buildMemberChatPath = (conversationUuid: string, showProfile: boolean): string => {
  let chatPath = `/chat/${conversationUuid}`;
  if (showProfile) {
    chatPath += '?memberProfileDrawerVisible=true';
  }
  return chatPath;
};
